module.exports = __webpack_public_path__ + "static/media/select_gray.c7f4f986.svg";